// src/utils/helpers.js

// Status constants
export const USER_STATUS = {
  ACTIVE: 0,
  SUSPENDED: 1,
  EXPIRED: 2
};

// Get status information with icon, label, and class
export const getStatusInfo = (status) => {
  switch (status) {
    case USER_STATUS.ACTIVE:
      return {
        value: USER_STATUS.ACTIVE,
        label: 'Active',
        class: 'active',
        icon: 'bi-check-circle-fill',
        color: '#10b981'
      };
    case USER_STATUS.SUSPENDED:
      return {
        value: USER_STATUS.SUSPENDED,
        label: 'Suspended',
        class: 'suspended',
        icon: 'bi-pause-circle-fill',
        color: '#f59e0b'
      };
    case USER_STATUS.EXPIRED:
      return {
        value: USER_STATUS.EXPIRED,
        label: 'Expired',
        class: 'expired',
        icon: 'bi-x-circle-fill',
        color: '#ef4444'
      };
    default:
      return {
        value: status,
        label: 'Unknown',
        class: 'unknown',
        icon: 'bi-question-circle-fill',
        color: '#6b7280'
      };
  }
};

// Format date and time
export const formatDateTime = (dateString) => {
  const date = new Date(dateString);
  return {
    time: date.toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: false 
    }),
    date: date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }),
    full: date.toLocaleString('en-GB')
  };
};

// Copy to clipboard with feedback
export const copyToClipboard = async (text, label = 'Text') => {
  try {
    await navigator.clipboard.writeText(text);
    return { success: true, message: `${label} copied!` };
  } catch (err) {
    return { success: false, message: 'Failed to copy' };
  }
};

// Generate random password
export const generatePassword = (length = 12) => {
  const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*';
  let password = '';
  for (let i = 0; i < length; i++) {
    password += charset.charAt(Math.floor(Math.random() * charset.length));
  }
  return password;
};